export enum ProjectType {
    Illustrations = 1,
    GameUIDesign = 2,
    Projects = 3
}